<template>
<div class="skipDetail">
     <div class="date gray font16 flex-between">
          <span  class="img1" @click="getDate(1)"><img src='@/assets/img/step/left.png'></span>
          <span>{{dayName}}</span>
          <span  class="img1" @click="num>0?getDate(2):''"><img src='@/assets/img/step/right.png' :class="today==curDate?'unclick':''"></span>
     </div>
     <div class="flex-between">
          <div class="con wid">
              <p class='gray font14 flex'><img src='@/assets/img/step/bracelet1.png' class="img2"><span>最大心率</span></p>
              <p class="gray font14">
                  <template v-if='details.exerciseHeartRate'><span class="curStep">{{details.exerciseHeartRate}}</span> 次/分钟</template>
                  <template v-else><span class="curStep">--</span></template>
              </p>
          </div>
          <div class="con wid">
              <p class='gray font14 flex'><img src='@/assets/img/step/motion1.png' class="img2"><span>最小心率</span></p>
              <p class="gray font14">
                  <template v-if='details.restingHeartRate'><span class="curStep">{{details.restingHeartRate}}</span> 次/分钟</template>
                  <template v-else><span class="curStep">--</span></template>
              </p>
          </div>
     </div>
     <div class="con" style="padding-left:0px">
       <template v-if="details.listData==1">
         <div class='times'><p v-for='(item,i) in xName' :key='i'>{{item}}</p></div>
         <chart id='charts1' :option='option1'></chart>
       </template>
       <template v-else>
            <div class='noData' style='padding:.2rem 0rem;font-size:.12rem'><div><img :src='require("@/assets/img/step/nobracelet.png")' style="width:1.4rem"><br />{{text}}</div></div>
       </template>
     </div>
     <div class="con flex-between">
        <p>热量消耗</p>                       
        <p class="gray font12">
           <template v-if='details.calorie'><span class='curStep'>{{details.calorie}}</span> 千卡</template>
           <template v-else><span class='curStep'>--</span></template>
        </p>
     </div>
     <div class='con font14'>
        <p class="font16">心率说明</p>
        <p class="gray" style="margin-top:.06rem">心率是指心脏每分钟跳动的次数，正常人安静状态下每分钟心跳 60到100 次，运动时心跳会加速，心肺功能较好的运动员在同等运动强度下心率会比正常人更低。</p>
     </div>
</div>
</template>
<script>
import {braceletReport} from "@/api/api.report";
import chart from './components/commonChart.vue';
  export default {
    data() {
      return {
        list:'',
        details:'',
        curDate:'',
        today:'',
        num:0,
        dayName:'',
        xName:['00:00','06:00','12:00','18:00','24:00'],
        option1:{},
        text:''
      }
    },
    components:{chart},
    created(){
      this.today=this.curDate=this.pubMethod.formatDate(new Date(),'yyyy-MM-dd');
      this.dayName=(new Date().getMonth()+1)+'月'+new Date().getDate()+'日'
      this.getDetail();
     
    },
    methods: {
      getDate(type){
        if(type==1){
          this.num++;
        }else{
          this.num--;
        }
        let curDate=new Date(),arr;
        let dates=new Date(curDate.getTime() - 24*60*60*1000*this.num);//前一天
        this.curDate=this.pubMethod.formatDate(dates,'yyyy-MM-dd');
        arr=this.curDate.split('-');
        this.dayName=parseInt(arr[1])+'月'+arr[2]+'日';
        this.getDetail();
      },
      getDetail(){
         braceletReport({
              studentId:this.loginUser.studentId,
              date:this.curDate
           }).then((data) => {
            if (data && data.result) {
           //  data.result={maxHeartRate:340,restingHeartRate:60,calorie:345,list:[{time:'01:22',heartRate:22},{time:'02:12',heartRate:62},{time:'02:22',heartRate:42},{time:'03:22',heartRate:42},{time:'05:22',heartRate:42}]}
                 data.result.calorie=data.result.calorie?Math.round(data.result.calorie / 1000):'';
                 this.details=data.result;
                 this.getArea();
                 if(this.details.skipInfo) return
                 this.text='暂无数据';
            }
           })
      },
      getArea(){
          let arr=this.details.list.map(item=>item.heartRate);
          let arr1=this.details.list.map(item=>item.time);
          // let stepValue=5;
          // var self = this;
          var chart = {
            type: "area",
            backgroundColor: "#fff",
            marginLeft:40,
            spacingLeft:0,
            marginRight:0,
            showAxes:true
          };
          // 标题
          var title = {text: ""};
          // X 轴
          var xAxis = {
            categories:arr1,
            labels: {
              // step: 360,
              // staggerLines:1,
              enabled: false
            }
          };
          // Y 轴
          var yAxis = {
            title: {
              text: null,
            },
            max:220,
            min:20,
            tickInterval:45,
            gridLineColor:'#fff',
            lineWidth: 1,
            allowDecimals: false,
          };
          var plotOptions={
            series:{
              lineWidth:1,
              turboThreshold:0,//性能阈值检查,
              connectNulls:true
            },
            area: {
              fillColor: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 0,
                  y2: 1
                },
                stops: [
                  [0, '#FFE6E6'],
                  [1, '#fff']
                ]
              },
              states: {
                hover: {
                  lineWidth: 1
                }
              },
              threshold: null
            }
          };
          var tooltip={
                formatter: function () {
                  return this.x+'<br />' + this.y + '</b><span class="gray">次/分钟</span>';
                }
              };
          var credits = {
            enabled: false
          };
          var legend = {
            enabled: false
          };
          var series = [
            {
              name: "心率",
              data: arr,
              color: "#FF5B5B",
            
            }
          ];

          var json = {
                exporting: {
                  enabled: false
                }
             };
          json.chart = chart;
          json.title = title;
          json.xAxis = xAxis;
          json.yAxis = yAxis;
          json.tooltip=tooltip;
          json.credits = credits;
          json.legend = legend;
          json.plotOptions = plotOptions;
          json.series = series;
          this.option1 =json;
      },
     
    },
  }
</script>
<style lang="scss" >
.skipDetail{
  padding:.12rem;
  .date{
    padding-bottom: .12rem;
    .img1{
      width: .32rem;
      height: .32rem;
      border-radius: 50%;
      background:#fff;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width:.14rem;
      }
      .unclick{
        opacity: .6;
      }
    }
  }
    .con{
       background:#fff;
       border-radius:8px;
       padding:.12rem;
       overflow: hidden;
       margin-bottom: .12rem;
       color:#000;
       position: relative;
       .curStep{
         color:#000;
         font-size: .24rem;
       }
       .times{
           position: absolute;
           bottom: .1rem;
           z-index: 3;
           width:calc(100% - .12rem);
           font-size:12px;
           display: flex;
           text-align: right;
           color:rgb(102, 102, 102);
           p{
            flex: 1;
            &:first-child{
              flex:0 0 41px;
              text-indent: 30px;
            }
           }
       }
     }
     .wid{
      flex: 1;
      padding-bottom: .16rem;
      
      .img2{
        width:.18rem;
        height: .18rem;
        margin-right: .04rem;
       }
      .flex{
        display: flex;
        margin-bottom: .13rem;
      }
      &:first-child{
        margin-right: .12rem;
      }
     }
}
</style>